import { buildRequest } from './request'
import { Response } from './response'
import { getCustomId } from '../common/custom-id'

export interface FormFields {
  firstName?: string
  name?: string
  mobile?: string
  weixin?: string
  email?: string
  company?: string
  position?: string
  companyLocation?: string
  proxyRegion?: string
  cooperateIntention?: string
  cooperationType?: '1' | '2' | '3' | '4' | '5' // 合作类型 1 其他 2 购买产品 3 区域代理 4 品牌合作 5消毒预售
  intendedPurchaseArea?: string
  source?: string
  remark?: string
  careerBackground?: string
  IndustryLevel1?: string // Fixme: 字段格式不统一，需要后台修改下
  countryCode?: string
  productType?: '1' | '2' | '3'
  salutation?: string
  utm_source?: string
  phone?: string
  address?: string
  title?: string
  numberOfEmployees?: string
  startTime?: string
  model?: string
  jobTitle?: string
  province?: string
  gclid_field?: string // google OCT
  productLine?: string[] | string
  intendedProductTypes?: Array<{
    crm_code: string
    hubspot_code: string
    zhichi_code: string
  }>
}

export interface SurveyFormFields {
  data: {
    [key: string]: string
  }
  email: string
}

const request = buildRequest('/api/v1')
const camelToSnakeCase = (str: string) =>
  !!str ? str[0] + str.slice(1).replace(/[A-Z]/g, (letter: string) => `_${letter.toLowerCase()}`) : str

function snakeobject(object: { [key: string]: any }) {
  const entries = Object.entries(object)
  const snakeObject = entries.reduce(
    (prev, currEntry) => {
      const originKey = currEntry[0]
      const originValue = currEntry[1]

      const snakekey: string = camelToSnakeCase(originKey)

      prev[snakekey] = originValue

      return prev
    },
    {} as { [key: string]: any }
  )

  return snakeObject
}

export async function submitForm(data: FormFields, inChina?: boolean): Promise<Response> {
  let _data: any = data
  if (data.cooperationType) {
    _data = { ...data, cooperationType: +data.cooperationType }
  }

  // append source field
  const searchParams = new URL(window.location.href).searchParams

  // source key from session
  let sourceFromSession: string | null = ''
  if (window.sessionStorage) {
    sourceFromSession = window.sessionStorage.getItem('next-source-key')
  }

  const sourceValue = data.utm_source || data.source || searchParams.get('source') || sourceFromSession || 'Website'
  _data.utm_source = sourceValue

  if (!_data.mobile) {
    _data.mobile = data.phone
  }

  // fetch Google OCT id
  // @ts-ignore
  if (window && typeof addGclid === 'function') {
    // @ts-ignore
    _data.gclid = addGclid()
  }

  // append custome_id
  _data.utm_customer_id = getCustomId()

  // 在请求头中添加 X-Region，传递地区信息
  const region = _data.region || _data.countryCode || ''
  const headerOptions = {
    'X-Region': region,
  }
  const res = await request(inChina ? '/front/commit/internal' : '/clue/commit', snakeobject(_data), headerOptions)
  return res
}

export async function submitCommonHubspot(data: SurveyFormFields): Promise<Response> {
  const res = await request('/front/commit/commonHubspot', data)
  return res
}
